import React, { useId } from 'react';

import { Box, FormControl, InputLabel, styled } from '@mui/material';

import { sharedClasses } from './sharedClasses';
import { DIVIDER, WHITE } from '../../../ThemeContext/constants';

interface IFormColorPickerProps {
  id?: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  fullWidth?: boolean;
}

const ColorInput = styled('input')({
  border: `1px solid ${DIVIDER}`,
  borderRadius: '6px',
  width: '100%',
  height: '40px',
  padding: '2px',
  cursor: 'pointer',
  backgroundColor: WHITE,
  '&::-webkit-color-swatch-wrapper': {
    padding: 0
  },
  '&::-webkit-color-swatch': {
    border: 'none',
    borderRadius: '4px'
  }
});

const FormColorPicker = ({
  id,
  label,
  value,
  onChange,
  required,
  fullWidth = false
}: IFormColorPickerProps) => {
  const generatedId = useId();
  const resolvedId = id ?? generatedId;

  return (
    <FormControl sx={{ width: fullWidth ? '100%' : 'auto' }} variant="standard">
      {label ? (
        <InputLabel shrink htmlFor={resolvedId} sx={sharedClasses.inputLabel}>
          {label}
          {required ? <span>*</span> : null}
        </InputLabel>
      ) : null}
      <Box sx={{ mt: label ? '24px' : 0 }}>
        <ColorInput
          id={resolvedId}
          onChange={(e) => onChange(e.target.value)}
          type="color"
          value={value}
        />
      </Box>
    </FormControl>
  );
};

export default FormColorPicker;
